// src/components/VLibras.jsx
import { useEffect } from "react";

export default function VLibras() {
  useEffect(() => {
    // 1. Evita carregar o script mais de uma vez se a página recarregar
    if (document.getElementById("vlibras-script")) return;

    // 2. Cria e injeta o script oficial do VLibras
    const script = document.createElement("script");
    script.id = "vlibras-script";
    script.src = "https://vlibras.gov.br/app/vlibras-plugin.js";
    script.async = true;
    script.onload = () => {
      if (window.VLibras) {
        new window.VLibras.Widget("https://vlibras.gov.br/app");
      }
    };
    document.body.appendChild(script);
  }, []);

  return (
    <div vw="true" className="enabled">
      <div vw-access-button="true" className="active"></div>
      <div vw-plugin-wrapper="true">
        <div className="vw-plugin-top-wrapper"></div>
      </div>
    </div>
  );
}